import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';
import { Button, Dropdown } from 'react-bootstrap';
import { dropDownStyle } from '../constants';
import { useAgendaActionsContext } from '../../../contexts/AgendaActionsContext';

const MENU_WIDTH = 220;

const menuItemStyle = {
  ...dropDownStyle,
  paddingTop: 1,
  paddingBottom: 1,
};

const agendaStatusItems = [
  { label: 'Agenda Reservada', status: 'Reservada' },
  { label: 'Agenda Cancelada', status: 'Cancelado' },
  { label: 'Agenda Fechada', status: 'Fechada' },
  { label: 'Agenda Feriado', status: 'Feriado' },
  { label: 'Agenda Marcada', status: 'Marcada' },
  { label: 'Agenda Aberta', status: 'Aberta' },
];

const pacienteStatusItems = [
  { label: 'Paciente Em Atendimento', status: 'Em Atendimento' },
  { label: 'Paciente Atendido', status: 'Atendido' },
  { label: 'Paciente Faltou', status: 'Faltou' },
  { label: 'Paciente no ECG', status: 'Solicitado' },
  { label: 'Autorizo Entrada', status: 'Autorizado' },
];

const AgendamentoActionsDropdown = ({
  agenda,
  preencherFormulario,
  handleAtividades,
  setShowReceitaModal,
  handleSelectFaturamento,
  handleAtualizarGuiaContextual,
}) => {
  const { alteraStatusAgenda, encaixeAgenda } = useAgendaActionsContext();
  const [show, setShow] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const handleClose = () => setShow(false);

  const handleToggle = e => {
    e?.stopPropagation();
    if (show) {
      handleClose();
      return;
    }
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();
    setMenuPosition({
      top: rect.bottom + window.scrollY,
      left: rect.right - MENU_WIDTH + window.scrollX,
    });
    setShow(true);
    preencherFormulario(agenda);
  };

  const handleStatusClick = status => {
    alteraStatusAgenda(agenda, status);
    handleClose();
  };

  const handleAtividadesClick = () => {
    handleAtividades(agenda);
    handleClose();
  };

  const handleFaturamentoClick = () => {
    if (agenda.CODPAC === 1) {
      toast.info('Não é permitido faturar para paciente NULO!');
      handleClose();
      return;
    }
    handleSelectFaturamento(agenda);
    handleClose();
  };

  const handleIrParaAgendaClick = () => {
    preencherFormulario(agenda, { focarPaciente: true });
    handleClose();
  };

  const handleEmitirReceitaClick = () => {
    setShowReceitaModal(true);
    handleClose();
  };

  const handleAtualizarObservacaoClick = () => {
    const obsField = document.getElementById('obs');
    if (obsField) {
      obsField.focus();
      obsField.select();
    }
    handleClose();
  };

  const handleEncaixeClick = () => {
    encaixeAgenda(agenda);
    handleClose();
  };

  const handleCancelarDefinitivoClick = () => {
    alteraStatusAgenda(agenda, 'Cancelada');
    handleClose();
  };

  useEffect(() => {
    if (!show) return undefined;

    const handleClickOutside = event => {
      const clickedButton = buttonRef.current?.contains(event.target);
      const clickedMenu = menuRef.current?.contains(event.target);
      if (!clickedButton && !clickedMenu) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [show]);

  return (
    <>
      <Button
        ref={buttonRef}
        size="sm"
        variant="success"
        aria-label="Menu de ações da agenda"
        aria-haspopup="menu"
        aria-expanded={show}
        onClick={handleToggle}
      >
        Menu
      </Button>
      {show &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            id={`dropdown-menu-${agenda.CODAGENDA}`}
            className="dropdown-menu show"
            role="menu"
            aria-label="Ações da agenda"
            onClick={e => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: menuPosition.top,
              left: menuPosition.left,
              zIndex: 1050,
              minWidth: MENU_WIDTH,
            }}
          >
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={handleAtividadesClick}
            >
              ATIVIDADES
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={handleFaturamentoClick}
            >
              FATURAMENTO
            </Dropdown.Item>
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={() => {
                handleAtualizarGuiaContextual(agenda);
                handleClose();
              }}
            >
              ATUALIZAR GUIA CONVÊNIO
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={handleIrParaAgendaClick}
            >
              Ir para Agenda
            </Dropdown.Item>
            <Dropdown.Divider />
            {agendaStatusItems.map(({ label, status }) => (
              <Dropdown.Item
                key={status}
                as="button"
                style={menuItemStyle}
                onClick={() => handleStatusClick(status)}
              >
                {label}
              </Dropdown.Item>
            ))}
            <Dropdown.Divider />
            {pacienteStatusItems.map(({ label, status }) => (
              <Dropdown.Item
                key={status}
                as="button"
                style={menuItemStyle}
                onClick={() => handleStatusClick(status)}
              >
                {label}
              </Dropdown.Item>
            ))}
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={handleEmitirReceitaClick}
            >
              Emitir Receita
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={handleAtualizarObservacaoClick}
            >
              Atualizar observação
            </Dropdown.Item>
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={handleEncaixeClick}
            >
              Encaixe na Agenda
            </Dropdown.Item>
            <Dropdown.Item
              as="button"
              style={menuItemStyle}
              onClick={handleCancelarDefinitivoClick}
            >
              Cancela Definitivo
            </Dropdown.Item>
          </div>,
          document.body
        )}
    </>
  );
};

export default AgendamentoActionsDropdown;
